import { render } from "./BtnCart.vue?vue&type=template&id=e2a4f6ae"
import script from "./BtnCart.vue?vue&type=script&lang=js"
export * from "./BtnCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__